import { render, staticRenderFns } from "./JoinFree.vue?vue&type=template&id=1c4faacb"
import script from "./JoinFree.vue?vue&type=script&lang=js"
export * from "./JoinFree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports